module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "profile"
  }, [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "profile-table",
    attrs: {
      "id": "profile-table",
      "span": 6
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileShow),
      expression: "profileShow"
    }]
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_vm._v(" 基本資料 ")]), _vm._v(" "), _c('div', {
    staticClass: "profile-item"
  }, [_c('div', {
    staticClass: "profile-title"
  }, [_vm._v(" 姓名 ")]), _vm._v(" "), _c('div', {
    staticClass: "profile-name"
  }, [_vm._v(" " + _vm._s(_vm.profile.user.displayname) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "profile-item"
  }, [_c('div', {
    staticClass: "profile-title"
  }, [_vm._v(" 帳號 ")]), _vm._v(" "), _c('div', {
    staticClass: "profile-name"
  }, [_vm._v(" " + _vm._s(_vm.profile.user.username) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "profile-item"
  }, [_c('div', {
    staticClass: "profile-title"
  }, [_vm._v(" 信箱 ")]), _vm._v(" "), _c('div', {
    staticClass: "profile-name"
  }, [_vm._v(" " + _vm._s(_vm.profile.user.email) + " ")])]), _vm._v(" "), (!_vm.authorId) ? _c('div', {
    staticClass: "profile-item"
  }, [_c('div', {
    staticClass: "profile-title"
  }, [_vm._v(" 密碼 ")]), _vm._v(" "), (!_vm.isResetPW) ? _c('el-button', {
    staticClass: "reset-btn",
    on: {
      "click": function($event) {
        return _vm.resetPassword(true)
      }
    }
  }, [_vm._v("重設密碼")]) : _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "block",
      "position": "relative"
    }
  }, [((_vm.showPass ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.newPW),
      expression: "profile.newPW"
    }],
    staticClass: "password-input",
    attrs: {
      "id": "password",
      "placeholder": "請輸入新密碼",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.newPW) ? _vm._i(_vm.profile.newPW, null) > -1 : (_vm.profile.newPW)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "change": function($event) {
        var $$a = _vm.profile.newPW,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile, "newPW", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile, "newPW", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile, "newPW", $$c)
        }
      }
    }
  }) : ((_vm.showPass ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.newPW),
      expression: "profile.newPW"
    }],
    staticClass: "password-input",
    attrs: {
      "id": "password",
      "placeholder": "請輸入新密碼",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.profile.newPW, null)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "change": function($event) {
        return _vm.$set(_vm.profile, "newPW", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.newPW),
      expression: "profile.newPW"
    }],
    staticClass: "password-input",
    attrs: {
      "id": "password",
      "placeholder": "請輸入新密碼",
      "type": _vm.showPass ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.profile.newPW)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "newPW", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "20px",
      "height": "20px",
      "margin-top": "13px",
      "margin-left": "-25px",
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.showPass ? '顯示密碼' : '隱藏密碼',
      "src": _vm.showPass ? _vm.openeye : _vm.nopeneye
    },
    on: {
      "click": function($event) {
        _vm.showPass = !_vm.showPass
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "block",
      "position": "relative"
    }
  }, [((_vm.showPass2 ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.checkNewPW),
      expression: "profile.checkNewPW"
    }],
    staticClass: "password-input",
    attrs: {
      "id": "check-password",
      "placeholder": "請再一次輸入，以便確認",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.checkNewPW) ? _vm._i(_vm.profile.checkNewPW, null) > -1 : (_vm.profile.checkNewPW)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "change": function($event) {
        var $$a = _vm.profile.checkNewPW,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile, "checkNewPW", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile, "checkNewPW", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile, "checkNewPW", $$c)
        }
      }
    }
  }) : ((_vm.showPass2 ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.checkNewPW),
      expression: "profile.checkNewPW"
    }],
    staticClass: "password-input",
    attrs: {
      "id": "check-password",
      "placeholder": "請再一次輸入，以便確認",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.profile.checkNewPW, null)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "change": function($event) {
        return _vm.$set(_vm.profile, "checkNewPW", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.checkNewPW),
      expression: "profile.checkNewPW"
    }],
    staticClass: "password-input",
    attrs: {
      "id": "check-password",
      "placeholder": "請再一次輸入，以便確認",
      "type": _vm.showPass2 ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.profile.checkNewPW)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "checkNewPW", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "20px",
      "height": "20px",
      "margin-top": "13px",
      "margin-left": "-25px",
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.showPass2 ? '顯示密碼' : '隱藏密碼',
      "src": _vm.showPass2 ? _vm.openeye : _vm.nopeneye
    },
    on: {
      "click": function($event) {
        _vm.showPass2 = !_vm.showPass2
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": _vm.savePassword
    }
  }, [_vm._v("儲存")]), _vm._v(" "), _c('el-button', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        return _vm.resetPassword(false)
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "profile-item"
  }, [_c('div', {
    staticClass: "profile-title"
  }, [_vm._v(" 部門 ")]), _vm._v(" "), _c('div', {
    staticClass: "profile-name"
  }, [_vm._v(" " + _vm._s(_vm.profile.actual_dep.name + "(" + _vm.profile.dep.title + ")") + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "profile-item"
  }, [_c('div', {
    staticClass: "profile-title"
  }, [_vm._v(" 權限 ")]), _vm._v(" "), _c('div', {
    staticClass: "profile-name"
  }, [_vm._v(" " + _vm._s(_vm.formatLevel(_vm.profile.level)) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "profile-item"
  }, [_c('div', {
    staticClass: "profile-title"
  }, [_vm._v(" 身份 ")]), _vm._v(" "), _c('div', {
    staticClass: "profile-name"
  }, [_vm._v(" " + _vm._s(_vm.formatManager(_vm.profile.isManager)) + " ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "transparent"
    }
  }, [_vm._v("\n\t\t\t\tFrontend vesrion: " + _vm._s(_vm.frontendVersion) + " "), _c('br'), _vm._v("\n\t\t\t\tBackend Version: " + _vm._s(_vm.backendVersion) + "\n\t\t\t")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.profile),
      expression: "hint.display && this.$store.state.hintStatus.profile"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d8efd50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Profile.vue
// module id = 900
// module chunks = 170